'use strict';

import {Component, Input, Output, EventEmitter} from "@angular/core";
const dropdownHtml = <string>require('text!./dropdownNg2.html');

export type DropdownItem = {
    id: number | string,
    display: string
};

@Component({
    selector: 'dropdown',
    template: dropdownHtml,
})
export class DropdownComponent {
    @Input() list: Array<DropdownItem>;
    @Input() selection: DropdownItem;
    @Input() placeholder: string;
    @Output() choice = new EventEmitter();

    expanded = false;

    constructor() {}

    select(item: DropdownItem) {
        this.selection = item;
        this.choice.emit(item.id);
        this.expanded = false;
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/dropdownNg2.ts